import React from "react";
import { Check, TriangleAlert} from 'lucide-react';

import ClimbingJourneyIcon from "../../../assets/climbing-jouney-lighblue-transparent.svg";
import DiamondTransparentBkg from "../../../assets/diamond-transparent-bkg-preview.png";
import goldenKeyIcon from "../../../assets/golden-key-transparent.png";
import BiohazardTransparentBkg from "../../../assets/warning-hazard-sign-transparent-bkg-preview.png";
import RedFireSignTransparentBkg from "../../../assets/red-fire-sign-transparentbkg-preview.png";

export default function WrittenAnalysisReport(props){

    return(
    <div className="profile-assessment-container">
        <h1 className="position-rel t-50 card-label">Profile assessment of your two most dominant character Types</h1>
        {
            props.data.map((Profile, index)=>(
                <div key={index} className="character-type-container position-rel t-50">
                    <h1 className="top-title mt-15">{Profile.profileData.title}</h1>
                    <h3>{Profile.profileData.subtitleDescription}</h3>

                    <div className="flex-column-items-left">
                        <h3 className="bullet-point-title">{Profile.profileData.strengths.title}</h3>
                        <div className="text-left flex-column-items-left"> 
                            <ul key={Profile.profileData.strengths.title}>
                                {Profile.profileData.strengths.enumeration.map((strength)=>(                                   
                                    <li key={strength} className="font-s12 bullet-point-item-container-grid">
                                        <Check color="green" size={24} className="icon-item"/>
                                        <span className="bullet-point-item">{strength}</span>
                                    </li> 
                                ))}
                            </ul>
                        </div>    
                    </div>
                    
                    <div className="flex-column-items-left">
                        <h3 className="bullet-point-title">{Profile.profileData.performance.title}</h3>
                        <div className="text-left flex-column-items-left"> 
                            <ul key={Profile.profileData.performance.title}>
                                {Profile.profileData.performance.enumeration.map((perf)=>(
                                <li key={perf} className="font-s12 bullet-point-item-container-grid">
                                    <Check color="green" size={24} className="icon-item"/>
                                    <span className="bullet-point-item">{perf}</span>
                                </li>
                                ))}
                            </ul>
                        </div>                        
                    </div>                   

                    <div className="flex-column-items-left">
                        <h3 className="bullet-point-title">{Profile.profileData.challenges.title}</h3>
                        <div className="text-left flex-column-items-left"> 
                            <ul key={Profile.profileData.challenges.title}>
                                {Profile.profileData.challenges.enumeration.map((challenge)=>(
                                <li key={challenge} className="font-s12 bullet-point-item-container-grid">
                                    <TriangleAlert className="font-color-red icon-item" />
                                    <span className="bullet-point-item">{challenge}</span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                   
                    <div className="flex-column-items-left position-rel text-left">
                        <h3 className="section-title"> <strong> {Profile.profileData.growth.title} </strong> : 
                            {Profile.profileData.growth.explanation}
                        </h3>
                    </div>
                    <div className="text-left flex-column-items-left">
                        <ul key={Profile.profileData.growth.title}>
                            {Profile.profileData.growth.enumeration.map((growth)=>(
                            <li key={growth} className="font-s12 bullet-point-item-container-grid">
                                <img src={DiamondTransparentBkg} alt="diamond-icon" className="icon-item diamond-icon"/>
                                <span className="bullet-point-item" >{growth}</span>
                            </li>
                            ))}
                        </ul>
                    </div>
                   

                    <div className="flex-column-items-left position-rel text-left">
                        <h3 className="section-title">{Profile.profileData.childhoodExperiences.title}</h3>
                        <ul key={Profile.profileData.childhoodExperiences.title}>
                            {Profile.profileData.childhoodExperiences.explanation.map((childhood)=>(
                            <li key={childhood} className="section-paragraph"><span>{childhood}</span></li>
                            ))}
                        </ul>
                    </div>

                    <div className="flex-column-items-left position-rel text-left">
                        <h3 className="section-title">{Profile.profileData.wounding.title}</h3>
                        <span className="section-paragraph">{Profile.profileData.wounding.explanation}</span>
                    </div>

                    <div className="flex-column-items-left position-rel text-left">
                        <h3 className="section-title">{Profile.profileData.primaryObstacles.title}</h3>
                        <span className="section-paragraph">{Profile.profileData.primaryObstacles.subtitleDescription}</span>
                        
                        <h3 className="section-title">{Profile.profileData.primaryObstacles.coreChallenge.title}</h3>
                        <ul key={Profile.profileData.primaryObstacles.coreChallenge.title} >
                            {Profile.profileData.primaryObstacles.coreChallenge.enumeration.map((coreChallenge)=>(
                            <li key={coreChallenge} className="font-s12 bullet-point-item-container-grid-50col">
                                 <img src={RedFireSignTransparentBkg} alt="red-fire-alert-sign" className="font-color-red icon-item-50col red-fire-alert-icon"/>
                                <span className="bullet-point-item-50col ml-25">{coreChallenge}</span>
                            </li>
                            ))}
                        </ul>                    
                    </div>

                    <div className="flex-column-items-left position-rel text-left">
                        <h3 className="section-title">{Profile.profileData.hiddenCost.title}</h3>
                        <div className="font-s12 bullet-point-item-container-grid-50col">
                            <img src={BiohazardTransparentBkg} alt="biohazard-warning" className="icon-item-50col biohazard-warning-icon"/>
                            <span className="bullet-point-item-50col section-paragraph ml-10">{Profile.profileData.hiddenCost.description}</span>
                        </div>
                    </div>

                    <div className="flex-column-items-left position-rel text-left">
                        <h3 className="section-title">{Profile.profileData.doorwayToSuccess.title}</h3>
                        <span className="section-paragraph">{Profile.profileData.doorwayToSuccess.description}</span>
                         <ul key={Profile.profileData.doorwayToSuccess.description} >
                            {Profile.profileData.doorwayToSuccess.enumeration.map((strategy)=>(
                            <li key={strategy} className="font-s12 bullet-point-item-container-grid-50col">
                                 <img src={goldenKeyIcon} alt="golden-key" className="icon-item-50col golden-ley-icon"/>
                                <span className="bullet-point-item-50col ml-25">{strategy}</span>
                                </li>
                            ))}
                        </ul> 
                    </div>

                     <div className="flex-column-items-left position-rel text-left">
                        <h3 className="section-title">{Profile.profileData.transformation.title}</h3>
                         <ul key={Profile.profileData.transformation.title}>
                            {Profile.profileData.transformation.explanation.map((trasnformation)=>(
                            <li key={trasnformation} className="section-paragraph"><span>{trasnformation}</span></li>
                            ))}
                        </ul>
                    </div>

                </div>        
            ))
        }

        <div className="footer-section">
        </div>
    </div>
    );
}